<!-- @format -->

<div class="store-services-container small-sidenav top-border hmf-p-0 hmf-m-m-0 hmf-mx-s">
	<div class="hmf-w-100 hmf-my-s hmf-mr-xs hmf-display-flex hmf-align-items-center">
		<div class="badge-container">
			<shared-media-component-media
				[ngClass]="'service-icon'"
				[altText]="'Fitting Service'"
				[gif]="homrInStoreServicesContent?.icon"
				[itemTitle]="''"></shared-media-component-media>
		</div>
		<div class="description-container">
			<p class="service-title hmf-header-bold-xs hmf-mb-xxxs">
				{{ homrInStoreServicesContent?.headline | titlecase }}
			</p>
			<p class="service-details hmf-body-s hmf-mb-0 hmf-w-100">
				{{ homrInStoreServicesContent?.pdpText }}
				<button
					hmf-action-text
					class="hyperlink info-icon"
					aria-label="Open Drawer"
					(click)="openDrawer()">
					<homefield-icon
						width="16px"
						height="16px"
						name="alert-info-outlined"
						class="hmf-display-inline-flex"
						fill="var(--hmf-label-secondary-subtle-static)"></homefield-icon>
				</button>
			</p>
		</div>
	</div>
</div>

<ng-template #drawerContent>
	<div class="hmf-p-s hmf-p-md-m overflow-y-auto">
		<div
			class="hmf-body-m"
			[innerHTML]="homrInStoreServicesContent?.primaryPanelContent"></div>
		@if (homrInStoreServicesContent?.secondaryPanelContent) {
			<div
				class="hmf-body-m hmf-py-s"
				[innerHTML]="homrInStoreServicesContent?.secondaryPanelContent"></div>
		}
		@if (
			homrInStoreServicesContent?.cta?.length > 0 &&
			!utilityService.isObjectInArrayEmpty(homrInStoreServicesContent?.cta)
		) {
			<div class="hmf-mb-m">
				<a
					hmf-button
					variant="primary"
					[dataEm]="'FittingServices_' + homrInStoreServicesContent?.cta[0].linkTitle"
					class="full-width"
					[href]="homrInStoreServicesContent?.cta[0].link"
					[text]="homrInStoreServicesContent?.cta[0].linkTitle"></a>
			</div>
		}
		<div>
			<a
				hmf-button
				variant="primary"
				[dataEm]="'FittingServices_FindAStore'"
				href="/s/stores"
				class="full-width"
				aria-label="Find a store"
				text="Find a store"></a>
		</div>
		<div class="hmf-py-xs hmf-px-m hmf-m-auto hmf-text-align-center">
			<span>
				Services vary by location. Contact your local store to determine which
				{{ chain.chainIdentifierAbbr !== 'pl' ? 'PROS' : '' }} services are available.
			</span>
		</div>
	</div>
</ng-template>
